import React from 'react';
import MlxBlockUI from '../../../components/common/MlxBlockUI/MlxBlockUI';
import withSidebar from '../../../hoc/withSideBar/withSideBar';
import VenueOverview from './components/VenueOverview';
import StaffStatus from './components/StaffStatus';
import ShiftDistribution from './components/ShiftDistribution';
import WeeklyRevenue from './components/WeeklyRevenue';
import StaffByLocation from './components/StaffByLocation';
import ReportGenerator from './components/ReportGenerator';
import RecentActivity from './components/RecentActivity';
import {
    venueOverviewData,
    currentStaffStatusData,
    shiftDistributionData,
    weeklyRevenueData,
    staffByLocationData,
    staffUtilizationData,
    reportGeneratorData,
    recentActivityData,
} from './mockData';
import './OrgDashboard.scss';

function OrgDashboard() {
    const isLoading = false;

    return (
        <div className="page-section">
            <span className="page-header">Dashboard</span>
            <MlxBlockUI blocked={isLoading}>
                <div className="page-content h-100 overflow-auto">
                    <div className="content-body dashboard-content">
                        {/* Venue Overview Section */}
                        <div className="row mb-4">
                            <div className="col-12">
                                <VenueOverview venues={venueOverviewData} />
                            </div>
                        </div>

                        {/* Staff Status and Shift Distribution Row */}
                        <div className="row mb-4">
                            <div className="col-md-4">
                                <StaffStatus data={currentStaffStatusData} />
                            </div>
                            <div className="col-md-4">
                                <ShiftDistribution data={shiftDistributionData} />
                            </div>
                            <div className="col-md-4">
                                <WeeklyRevenue data={weeklyRevenueData} />
                            </div>
                        </div>

                        {/* Staff by Location Section */}
                        <div className="row mb-4">
                            <div className="col-12">
                                <StaffByLocation data={staffByLocationData} utilizationData={staffUtilizationData} />
                            </div>
                        </div>

                        {/* Report Generator Section */}
                        <div className="row mb-4">
                            <div className="col-12">
                                <ReportGenerator reports={reportGeneratorData} />
                            </div>
                        </div>

                        {/* Recent Activity Section */}
                        <div className="row">
                            <div className="col-12">
                                <RecentActivity data={recentActivityData} />
                            </div>
                        </div>
                    </div>
                </div>
            </MlxBlockUI>
        </div>
    );
}

export default withSidebar(OrgDashboard);
